export const TempoSourceIcon = ({
  width,
  height,
  className,
}: {
  width?: number;
  height?: number;
  className?: string;
}) => (
  <svg
    width={width ?? 16}
    height={height ?? 16}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
  >
    <path
      d="M10.7402 12.708C11.9722 13.0537 12.7033 14.3789 12.373 15.668L11.7754 18L9.5459 17.375L10.1436 15.041L3.46289 13.1689L4.05957 10.8359L10.7402 12.708Z"
      fill="currentColor"
    />
    <path
      d="M17 6.95801L14.7695 7.58301L16.5596 14.5723L14.3301 15.1982L12.54 8.20898C12.2099 6.92004 12.941 5.59573 14.1729 5.25L16.4023 4.625L17 6.95801Z"
      fill="currentColor"
    />
    <path
      d="M12.7871 3.70703L7.89746 8.82324C6.99566 9.76662 5.5337 9.76651 4.63184 8.82324L3 7.11621L4.63184 5.4082L6.26465 7.11621L11.1553 2L12.7871 3.70703Z"
      fill="currentColor"
    />
  </svg>
);
